export const EVENT_CURRENCY_DEFAULT = 'EUR';

